// The address a person typed into the builder, kept for this tab so the login
// page can fill it in (#319): they gave it a minute ago, so asking again reads
// as a different site.
//
// sessionStorage, on purpose. The server never hands an address back (#264:
// /api/v1/qr_codes/recent says only whether one is saved), and an address
// kept for the browser would greet the next person on a shared computer. A
// tab's copy goes when the tab closes. The login page and the auth callback
// read and clear the same key (app/views/sessions/*.html.erb).
export const CREATOR_EMAIL_KEY = "tq_creator_email"

export function rememberCreatorEmail(email) {
  const value = (email || "").trim().toLowerCase()
  if (!value) return
  try { window.sessionStorage.setItem(CREATOR_EMAIL_KEY, value) } catch { /* the login page just starts empty */ }
}
